<script>
  export default {
    data () {
      return {
          cleanModal: false,
          showModal: false,
          loadingSubmit: false,
      }
      },
    watch: {
      showModal: {
        immediate: true,
        deep: true,
        handler(newValue, oldValue) {
            if (newValue) {
                document.body.classList.add('no-scroll');
            }
            if (!newValue) {
                document.body.classList.remove('no-scroll');
            }
        }
      }
    },
    props: {
      start_opened: {
        type: Boolean,
        dafault: false,
      },
      closeLabel: {
        type: String,
        default: "Fechar"
      },
    },
    methods: {
      close() {
        this.showModal = false;
      },
      open(){
        this.showModal = true;
      }
    },
    beforeMount() {
      this.$data.showModal = this.start_opened;
    }, 
    created() {
      const that = this;
      document.addEventListener('keyup', function (evt) {
        if (evt.keyCode === 27) {
          that.close();
        }
      });
    }
  }
</script>

<template>
  <div class="modal-component" :showmodal="showModal">
    <div bg-modal></div>
    <div class="modal-box" ref="modal-page">
      <div header>
        <slot name="header"></slot>
        <span class="icon-close" @click="close">
          <div class="justify-center column">
            <i class="bi bi-times"></i>
            <div class="close-text">{{ closeLabel }}</div>
          </div>
        </span>
      </div>
      <div body>
        <slot name="body"></slot>
      </div>
    </div>
  </div>
</template>